<template>
    <div class="smart-video" @mousemove="mouseMoving" @click="muteVideo">
        <div class="cursor" :class="{ 'show' : show }">
            <div class="icon mute" v-if="!enableIcon">
                <svg id="mute-speaker" xmlns="http://www.w3.org/2000/svg" width="37" height="30" viewBox="0 0 37 30">
                <path id="Path_4284" data-name="Path 4284" d="M1.781,35.6H8.639l7.6,5.718A1.773,1.773,0,0,0,19.09,39.9V13.469a1.785,1.785,0,0,0-2.85-1.422l-7.6,5.718H1.781A1.785,1.785,0,0,0,0,19.543V33.854A1.779,1.779,0,0,0,1.781,35.6Z" transform="translate(0 -11.686)" fill="#fff"/>
                <path id="Path_4285" data-name="Path 4285" d="M90.462,39.179a2.1,2.1,0,0,0-2.939,0l-3.5,3.5-3.5-3.5a2.076,2.076,0,0,0-2.939,2.933l3.5,3.5-3.5,3.5a2.087,2.087,0,1,0,2.969,2.933l3.5-3.5,3.5,3.5A2.087,2.087,0,1,0,90.521,49.1l-3.563-3.5,3.5-3.5A2.09,2.09,0,0,0,90.462,39.179Z" transform="translate(-54.123 -30.611)" fill="#fff"/>
                </svg>
            </div>
            <div class="icon enable" v-if="enableIcon">
                <svg id="mute-speaker" xmlns="http://www.w3.org/2000/svg" width="19.09" height="30" viewBox="0 0 19.09 30">
                <path id="Path_4284" data-name="Path 4284" d="M1.781,35.6H8.639l7.6,5.718A1.773,1.773,0,0,0,19.09,39.9V13.469a1.785,1.785,0,0,0-2.85-1.422l-7.6,5.718H1.781A1.785,1.785,0,0,0,0,19.543V33.854A1.779,1.779,0,0,0,1.781,35.6Z" transform="translate(0 -11.686)" fill="#fff"/>
                </svg>
            </div>
        </div>
        <video :src="getVideoURL" autoplay loop muted playsinline preload="auto" type="video/mp4"></video>
        <div class="mobile-icons">
            <div class="icon mute" v-if="!enableIcon">
                <svg id="mute-speaker" xmlns="http://www.w3.org/2000/svg" width="37" height="30" viewBox="0 0 37 30">
                <path id="Path_4284" data-name="Path 4284" d="M1.781,35.6H8.639l7.6,5.718A1.773,1.773,0,0,0,19.09,39.9V13.469a1.785,1.785,0,0,0-2.85-1.422l-7.6,5.718H1.781A1.785,1.785,0,0,0,0,19.543V33.854A1.779,1.779,0,0,0,1.781,35.6Z" transform="translate(0 -11.686)" fill="#fff"/>
                <path id="Path_4285" data-name="Path 4285" d="M90.462,39.179a2.1,2.1,0,0,0-2.939,0l-3.5,3.5-3.5-3.5a2.076,2.076,0,0,0-2.939,2.933l3.5,3.5-3.5,3.5a2.087,2.087,0,1,0,2.969,2.933l3.5-3.5,3.5,3.5A2.087,2.087,0,1,0,90.521,49.1l-3.563-3.5,3.5-3.5A2.09,2.09,0,0,0,90.462,39.179Z" transform="translate(-54.123 -30.611)" fill="#fff"/>
                </svg>
            </div>
            <div class="icon enable" v-if="enableIcon">
                <svg id="mute-speaker" xmlns="http://www.w3.org/2000/svg" width="19.09" height="30" viewBox="0 0 19.09 30">
                <path id="Path_4284" data-name="Path 4284" d="M1.781,35.6H8.639l7.6,5.718A1.773,1.773,0,0,0,19.09,39.9V13.469a1.785,1.785,0,0,0-2.85-1.422l-7.6,5.718H1.781A1.785,1.785,0,0,0,0,19.543V33.854A1.779,1.779,0,0,0,1.781,35.6Z" transform="translate(0 -11.686)" fill="#fff"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["contentData"],
    data() {
        return {
            enableIcon: true,
            show: false,
        }
    },
    mounted() {
       this.defData()
    },
    computed: {
        getVideoURL() {
            return _.get(this.contentData, 'data.list.0.video.videoFile.url')
        }
    },
    methods: {
        defData() {
        // var vid = document.querySelector('.smart-video video')
        // vid.addEventListener('loadeddata', function() {
        //     vid.play()
        // })
        },
        mouseMoving(e) {
            this.show = true
            document.querySelector('.smart-video .cursor').style.transform = `translate(${e.offsetX - 55}px, ${e.offsetY - 55}px)`
        },
        muteVideo() {
            var vid = document.querySelector('.smart-video video')
            this.enableIcon = !this.enableIcon
            vid.muted = !vid.muted;
        }
    },
}
</script>

<style>

.smart-video {
    position: relative;
    width: 100%;
    padding-bottom: 56%;
    overflow: hidden;
}
.smart-video .mobile-icons {
    position: absolute;
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
    bottom: 10px;
    left: 10px;
}
.smart-video .cursor {
    width: 110px;
    backface-visibility: hidden;
    height: 110px;
    transition: 0.1s;
    pointer-events: none;
    border-radius: 50%;
    border: 2px solid white;
    background: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
}
.smart-video .cursor.show {
    opacity: 1;
}
.smart-video .cursor .icon {
    display: flex;
    justify-content: center;
    align-items: center;
}
.smart-video video {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Responsive */
@media (max-width: 1900px) {

}
@media (max-width: 1679px) {
    
}
@media (max-width: 1365px) {
    
}
@media (max-width: 1023px) {
    .smart-video .cursor {
        display: none;
    }
    .smart-video .mobile-icons {
        display: flex;
    }
}
@media (max-width: 767px) {
    
}
/* Responsive */

</style>